import { axios } from "../axios.instance";

export type CompareImagesRequest = FormData;

export type CompareImagesResponse = {
  isVerified: boolean;
};

export const compareImages = async (body: CompareImagesRequest): Promise<CompareImagesResponse> => {
  const { data } = await axios.post("users/compare-images", body);

  return data;
};
